// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"CheckBox_checkboxWrapper__NKgCG","checkbox":"CheckBox_checkbox__2r37K","label":"CheckBox_label__Q0Qga"};